<template>
    <div class="consent d-inline-block">
        <span>Durch das Absenden dieser Bestellung bestätigst Du
<!--            die <router-link-->
<!--                :to="{ name: 'AGB'}">AGB</router-link> und -->
            unsere <router-link :to="{ name: 'Datenschutz'}">Datenschutzbestimmungen</router-link>.
<!--            und haben die <router-link-->
<!--                :to="{ name: 'agb'}">Widerrufsbelehrung</router-link> und das Muster-Widerrufsformular zur Kenntnis genommen-->
        </span>
        <!--        <span>Durch Anklicken von "{{buttonName}}" bestätigen Sie die <router-link :to="{ name: 'agb'}">AGB</router-link>, die <router-link :to="{ name: 'datenschutz'}">Datenschutzbestimmungen</router-link> und haben die <router-link :to="{ name: 'agb'}">Widerrufsbelehrung</router-link> und das Muster-Widerrufsformular zur Kenntnis genommen</span>-->
    </div>
</template>

<script>
    export default {
        name: "orderconsent",
        // props: ['buttonName']
    }
</script>

<style lang="scss" scoped>
    @import '../styles/base';

    .consent {
        padding: 15px 0;

        span {
            color: rgba($font-color, 0.8);
        }
        a{
            color: $font-color;
        }
    }

</style>